import React from "react";
import { DatePicker, Form, Input, InputNumber, Typography } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

export const FIELD_TYPES = ["String", "Number", "Date"];

// Groups created before the type picker hold hand-typed types ("text", "date", …). Anything
// unknown is edited as text so the column is never silently hidden.
export const fieldType = field =>
  FIELD_TYPES.find(type => type.toLowerCase() === String(field?.type || "").toLowerCase()) ||
  "String";

export const renderTicketFields = (fields = [], t) =>
  fields.map((field, index) => {
    const type = fieldType(field);
    const common = {
      key: `${field.name}-${index}`,
      name: ["ticketValues", field.name],
      label: <Text strong>{field.name}</Text>,
      rules: [{ required: true, message: t("enter", { field: field.name }) }]
    };
    if (type === "Date") {
      return (
        <Form.Item {...common}>
          <DatePicker size="large" style={{ width: "100%" }} format="DD/MMM/YYYY" />
        </Form.Item>
      );
    }
    if (type === "Number") {
      return (
        <Form.Item {...common}>
          <InputNumber size="large" style={{ width: "100%" }} />
        </Form.Item>
      );
    }
    return (
      <Form.Item {...common}>
        <Input size="large" />
      </Form.Item>
    );
  });

// Stored values → form values (dates become dayjs objects).
export const toFormValues = (fields = [], ticketValues = {}) =>
  Object.fromEntries(
    fields.map(field => {
      const value = ticketValues?.[field.name];
      if (fieldType(field) === "Date") {
        return [field.name, value && dayjs(value).isValid() ? dayjs(value) : undefined];
      }
      if (fieldType(field) === "Number") {
        return [
          field.name,
          value === "" || value == null || isNaN(value) ? undefined : Number(value)
        ];
      }
      return [field.name, value];
    })
  );

// Form values → stored values (dates as YYYY-MM-DD).
export const fromFormValues = (fields = [], values = {}) =>
  Object.fromEntries(
    fields.map(field => {
      const value = values?.[field.name];
      return [
        field.name,
        fieldType(field) === "Date" && value ? dayjs(value).format("YYYY-MM-DD") : (value ?? null)
      ];
    })
  );

export const formatTicketValue = (field, value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (fieldType(field) === "Date" && dayjs(value).isValid())
    return dayjs(value).format("DD MMM YYYY");
  return String(value);
};
